export default __webpack_public_path__ + "static/media/PM.cb35743a.svg";